import React from "react";
import PropTypes from 'prop-types';

/*
 * Component to display email links
 */
export function EmailLink(props) {
    let emailHref = "mailto: " + props.emailAddress;
    if (props.subjectLine) {
        //let subjectLine = props.subjectLine.replace(" ", "%20");
        emailHref += "?subject= " + props.subjectLine;
    }

    return <a className="email-link" href={emailHref}>
        <span className="details-icon-prepend">
            <span className="icon-col"><span className="icon-messages"></span></span>
            <span className="details-col">{props.linkText ? props.linkText : props.emailAddress }</span>
        </span>
    </a>;
}

EmailLink.propTypes = {
    emailAddress: PropTypes.string,
    subjectLine: PropTypes.string,
    linkText: PropTypes.string
};
